import { render, staticRenderFns } from "./product-title.vue?vue&type=template&id=b8d996a8&scoped=true&"
import script from "./product-title.vue?vue&type=script&lang=js&"
export * from "./product-title.vue?vue&type=script&lang=js&"
import style0 from "./product-title.vue?vue&type=style&index=0&id=b8d996a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d996a8",
  null
  
)

export default component.exports